import { Component, Prop, Watch } from "vue-property-decorator";
import * as moment from "moment";
import InputDefaultForm from "../../default/InputDefaultForm";
import { InputOption } from "../../../../models/Input";

@Component
export default class InputDateForm extends InputDefaultForm {
	@Prop()
	public dataInputOption!: InputOption;

	private selectedDate;
	public isAppear = false;

	public click(): void {
		this.isAppear = !this.isAppear;

		if (this.isAppear) {
			this.isFocused = true;
		}
	}

	public clickOutside(): void {
		this.close();
	}

	public updateSelectedDate(selectedDate: Date): void {
		this.resetState();

		this.dataInputOption.vmodel = selectedDate.toString();
		this.dataInputOption.display = selectedDate.toString();
		this.$emit("changed");
		this.close();
		this.$forceUpdate();
	}

	private close(): void {
		this.isAppear = false;
		this.isFocused = false;
	}

	@Watch("dataInputOption.vmodel")
	private syncDateInput(): void {
		this.setSelectedDate();
	}

	public keyup(e: any): void {
		this.setSelectedDate();
		if (this.dataInputOption.display || (this.dataInputOption.display !== this.dataInputOption.vmodel)) {
			this.dataInputOption.vmodel = e.target.value;
			this.$emit("changed");
		}
	}

	private setSelectedDate(): void {
		this.resetState();

		if (moment(this.dataInputOption.vmodel).isValid()) {
			this.selectedDate = this.dataInputOption.vmodel;
		} else {
			this.selectedDate = undefined;
		}

		this.$forceUpdate();
	}

	@Watch("dataInputOption.trigger")
	public checkValidation(): void {
		this.checkValidationDefault();

		if (this.dataInputOption.minDate !== undefined) {
			if (this.selectedDate < this.dataInputOption.minDate) {
				this.success = false;
				this.dataInputOption.error = true;
			}
		}
		
		this.$forceUpdate();
	}

	private resetState(): void {
		this.success = false;
		this.dataInputOption.error = false;
		this.dataInputOption.message = "";
	}
}



// WEBPACK FOOTER //
// ./src/shared/components/forms/extended/InputDate/InputDate.ts